import { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthContext } from "../context/auth-context";
import RequireAuth from "./require-auth";
import LoginPage from "../routes/LoginPage";
import HostsPage from "../routes/HostsPage";
import LoadingScreen from "./LoadingScreen";
import "./App.css";
import ActionsPage from "../routes/ActionsPage";
import HostPage from "../routes/HostPage";
import ReportsPage from "../routes/ReportsPage";
import PromoCodesPage from "../routes/PromoCodesPage";
import CustomPoiList from "../routes/CustomPoiList";
import CustomPoiEdit from "../routes/CustomPoiEdit";
import CustomPoiCollectionList from "../routes/CustomPoiCollectionList";
import CustomPoiCollectionEdit from "../routes/CustomPoiCollectionEdit";
import AnalyticsPage from "../routes/AnalyticsPage";
import SettingsPage from "../routes/SettingsPage";
import AudioAssetsPage from "../routes/AudioAssetsPage";

function App() {
  const { currentUser, isLoading } = useContext(AuthContext);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <Routes>
      {!currentUser ? (
        <>
          <Route index element={<LoginPage />} />
          <Route path="hosts" element={<Navigate replace to="/" />} />
          <Route path="hosts/:id" element={<Navigate replace to="/" />} />
          <Route path="reports" element={<Navigate replace to="/" />} />
          <Route path="promocodes" element={<Navigate replace to="/" />} />
          <Route path="custom-pois" element={<Navigate replace to="/" />} />
          <Route path="custom-pois/:id" element={<Navigate replace to="/" />} />
          <Route path="custom-poi-collections" element={<Navigate replace to="/" />} />
          <Route path="custom-poi-collections/:id" element={<Navigate replace to="/" />} />
          <Route path="custom-poi-collections/new" element={<Navigate replace to="/" />} />
          <Route path="analytics" element={<Navigate replace to="/" />} />
          <Route path="settings" element={<Navigate replace to="/" />} />
          <Route path="audioassets" element={<Navigate replace to="/" />} />
        </>
      ) : (
        <>
          <Route index element={<Navigate replace to="/hosts" />} />
          <Route
            path="hosts"
            element={
              <RequireAuth>
                <HostsPage />
              </RequireAuth>
            }
          />
          <Route
            path="actions"
            element={
              <RequireAuth>
                <ActionsPage />
              </RequireAuth>
            }
          />
          <Route
            path="hosts/:id"
            element={
              <RequireAuth>
                <HostPage />
              </RequireAuth>
            }
          />
          <Route
            path="reports"
            element={
              <RequireAuth>
                <ReportsPage />
              </RequireAuth>
            }
          />
          <Route
            path="promocodes"
            element={
              <RequireAuth>
                <PromoCodesPage />
              </RequireAuth>
            }
          />
          <Route
            path="custom-pois"
            element={
              <RequireAuth>
                <CustomPoiList />
              </RequireAuth>
            }
          />
          <Route
            path="custom-pois/:id"
            element={
              <RequireAuth>
                <CustomPoiEdit />
              </RequireAuth>
            }
          />
          <Route
            path="custom-poi-collections"
            element={
              <RequireAuth>
                <CustomPoiCollectionList />
              </RequireAuth>
            }
          />
          <Route
            path="custom-poi-collections/:id"
            element={
              <RequireAuth>
                <CustomPoiCollectionEdit />
              </RequireAuth>
            }
          />
          <Route
            path="custom-poi-collections/new"
            element={
              <RequireAuth>
                <CustomPoiCollectionEdit />
              </RequireAuth>
            }
          />
          <Route
            path="analytics"
            element={
              <RequireAuth>
                <AnalyticsPage />
              </RequireAuth>
            }
          />
          <Route
            path="settings"
            element={
              <RequireAuth>
                <SettingsPage />
              </RequireAuth>
            }
          />
          <Route
            path="audioassets"
            element={
              <RequireAuth>
                <AudioAssetsPage />
              </RequireAuth>
            }
          />
        </>
      )}
    </Routes>
  );
}

export default App;
